import * as React from "react";
import { Image, Text, VStack, Box, Icon } from "@chakra-ui/react";
import { format, parseISO } from "date-fns";
import { IoGitBranchOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import {
  useOnline,
  ImageType,
  getImageUrl,
  useOrganizationSettings
} from "duck";
import CaseLogo from "./assets/case.svg";
import { PublishButton } from "./components";

interface CaseProps {
  id: number;
  name: string;
  avatar: number | ImageType | null;
  createdFrom: { name: string; _id: number } | null;
  procedureDate: string;
  selected: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  pending?: boolean;
  needSync?: boolean;
}

const Case: React.FC<CaseProps> = ({
  id,
  avatar,
  createdFrom,
  procedureDate,
  selected,
  name,
  onClick,
  pending,
  needSync
}) => {
  const online = useOnline();
  const navigate = useNavigate();
  const { dateFormat } = useOrganizationSettings();
  const lastClickTime = React.useRef(0);

  return (
    <VStack
      data-id="medical-case"
      as={Link}
      to={`/cases/${id}/check-in`}
      spacing={2}
      onClick={event => {
        onClick(event);
        if (Date.now() - lastClickTime.current < 400) {
          navigate(`/cases/${id}/check-in`);
        } else {
          lastClickTime.current = Date.now();
        }
      }}
      cursor="pointer"
    >
      <Box
        position="relative"
        border="solid 2px"
        borderColor={selected ? "dark.500" : "transparent"}
        borderRadius="6px"
      >
        <Image
          borderRadius="6px"
          p="2px"
          width="70px"
          height="98px"
          objectFit="cover"
          src={
            avatar
              ? typeof avatar === "number"
                ? getImageUrl(avatar)
                : avatar.base64Format
              : CaseLogo
          }
          alt="Logo"
        />

        {(pending || needSync) && (
          <Box
            marginTop="0px !important"
            position="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            backgroundColor="rgba(255, 255, 255, 0.7)"
            borderRadius="6px"
          />
        )}
        {(pending || needSync) && online && (
          <PublishButton id={id} name={name} />
        )}
        {createdFrom && (
          <Icon
            as={IoGitBranchOutline}
            position="absolute"
            top="8px"
            left="8px"
            color="basic.500"
            backgroundColor={
              pending || needSync || !avatar ? "transparent" : "white"
            }
            borderRadius="sm"
          />
        )}
      </Box>

      <VStack spacing={-1}>
        <Text color="black" fontWeight={500} maxW="100px" textAlign="center">
          {name}
        </Text>
        <Text fontSize="sm" color="gray.500" maxW="100px" textAlign="center">
          {format(parseISO(procedureDate), dateFormat)}
        </Text>
      </VStack>
    </VStack>
  );
};

export default Case;
